import { searchAlgoliaClient } from "entities/algolia/constants";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import { Tag } from "entities/tags/types";
import { useThemePrimaryTagsQuery } from "entities/themeTagTypes/queries/useThemePrimaryTagsQuery";
import DeleteTagModal from "modules/tagsAndMetadataTags/components/DeleteTagModal";
import { FC } from "react";
import { InstantSearch } from "react-instantsearch";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import TableWithPagination from "shared/components/TableWithPagination";
import { StyledButton } from "../../../styled";
import PageFilterBar from "./components/PageFilterBar";
import ThemeTagDetailsContainer from "./components/ThemeTagDetails";
import { ThemeTagsPageProvider, useThemeTagsPage } from "./context";
import { getThemeTagsColumns } from "./helpers";

const algoliaThemeTagsIndexName =
  process.env.REACT_APP_ALGOLIA_THEME_TAGS_INDEX_NAME;

const ThemeTagsContainer = () => (
  <InstantSearch
    key={algoliaThemeTagsIndexName}
    searchClient={searchAlgoliaClient}
    indexName={algoliaThemeTagsIndexName}
    future={{ preserveSharedStateOnUnmount: true }}
  >
    <ThemeTagsPageProvider>
      <ThemeTags />
    </ThemeTagsPageProvider>
  </InstantSearch>
);

const ThemeTags: FC = () => {
  const themeTagsContextData = useThemeTagsPage();

  const {
    themeTagsDetailsDrawer,
    setSelectedTag,
    setOpenModal,
    loading,
    tableData,
    tagTypeFilterData,
  } = themeTagsContextData;
  const { isFetching: isFetchingTagTypes } = useThemePrimaryTagsQuery();

  const writeAccess = useRolePermission("themeTags:write");

  const columnsParams = {
    themeTagsDetailsDrawer: themeTagsDetailsDrawer,
    setSelectedTag: setSelectedTag,
    setOpenModal: setOpenModal,
    tagTypes: tagTypeFilterData.options,
    readOnly: !writeAccess.allowed,
  };

  const columns = getThemeTagsColumns(columnsParams);

  return (
    <>
      <SpaceBetweenCenter columnGap={"1rem"}>
        <PageFilterBar />
        {writeAccess.allowed && (
          <StyledButton
            title="Add new tag"
            size="small"
            onClick={() => themeTagsDetailsDrawer.openDrawer()}
          />
        )}
      </SpaceBetweenCenter>
      <TableWithPagination<Tag>
        columns={columns}
        emptyStateMessage="No Results Found"
        paginationMode="server"
        sortingMode="server"
        pageSizeOptions={[25, 50, 100]}
        loading={loading || isFetchingTagTypes}
        onRowClick={(params) => themeTagsDetailsDrawer.openDrawer(params.row)}
        {...tableData}
      />
      <ThemeTagDetailsContainer />
      <DeleteTagModal
        {...themeTagsContextData}
        tagsDetailsDrawer={themeTagsDetailsDrawer}
      />
    </>
  );
};
export default ThemeTagsContainer;
